import { render, staticRenderFns } from "./roleLimits.vue?vue&type=template&id=4aab1228&scoped=true"
import script from "./roleLimits.vue?vue&type=script&lang=js"
export * from "./roleLimits.vue?vue&type=script&lang=js"
import style0 from "./roleLimits.vue?vue&type=style&index=0&id=4aab1228&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aab1228",
  null
  
)

export default component.exports